import { ProcessedImage } from './types';

/** Strip any folder prefix so `yahoo_auction_data/000001.jpg` matches `000001.jpg`. */
function basename(path: string): string {
  return path.split(/[\\/]/).pop() || path;
}

export function matchImagesWithProducts(
  images: ProcessedImage[],
  imageFilenames: string[]
): string[] {
  return imageFilenames.map(filename => {
    const target = basename(filename);
    const image = images.find(img => basename(img.filename) === target);
    return image ? image.data : '';
  });
}

export function generateImageFilenames(productIndex: number, count: number): string[] {
  return Array.from({ length: count }, (_, i) =>
    `${String(productIndex * count + i + 1).padStart(6, '0')}.jpg`
  );
}
